import { render, staticRenderFns } from "./gptMenu.vue?vue&type=template&id=2a5eebe6&scoped=true&"
import script from "./gptMenu.vue?vue&type=script&lang=js&"
export * from "./gptMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5eebe6",
  null
  
)

export default component.exports